<template>
  <div class="page-content" id="setting-form">
    <Titlebar incrustation="fa-user-circle-o">
      <h1>{{ $t('settings.titles.me') }}</h1>
    </Titlebar>
    <div class="container full-height std-padding">
      <div class="row align-items-center justify-content-center full-height">
        <div class="col-12 col-xl-9 full-height">
          <UiCard>
            <div class="full-height">
              <div class="d-flex flex-column mb-4">
                <h2 class="m-0">
                  <i class="fa fa-user-circle-o mr-1"></i>
                  {{ $t('settings.titles.infos') }}
                </h2>
                <span class="text-sm text-gray-500 tw-ms-10">{{ user.clientCode }}</span>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.name') }}</label>
                <div class="col">
                  <input readonly="readonly" type="text" v-model="user.nom" class="form-input col" v-validate
                         data-vv-rules="required" name="nom" data-vv-as="Prénom NOM"/>
                  <span class="form-input-error" v-show="showErrors['nom'] && errors.has('nom')"
                        @click="hideError('nom')">{{ errors.first('nom') }}</span>
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.mail') }}</label>
                <div class="col">
                  <input readonly="readonly" type="text" v-model="user.email" class="form-input col" v-validate
                         data-vv-rules="required|email" data-vv-as="E-mail" name="email"/>
                  <span class="form-input-error" v-show="showErrors['email'] && errors.has('email')"
                        @click="hideError('email')">{{ errors.first('email') }}</span>
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.phone') }}</label>
                <div class="col">
                  <input readonly="readonly" type="text" v-model="userTelephone" class="form-input col" name="phone"
                         placeholder="__.__.__.__.__"/>
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.password') }}</label>
                <div class="col">
                  <Btn class="primary reverse col" style="text-align: center;"
                       @click.native.prevent="openPasswordModal">{{ $t('settings.form.passwordEdit') }}
                  </Btn>
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.language') }}</label>
                <div class="col-5">
                  <select class="form-input w-full" v-model="locale">
                    <option v-for="(lang,key) in langs" :value="lang.key">{{ lang.label }}</option>
                  </select>
                </div>
                <div class="col-3">
                  <Btn class="primary w-full" style="text-align: center;" @click.native.prevent="changeLanguage">
                    {{ $t('global.edit') }}
                  </Btn>
                </div>
              </div>
              <h2 class="mt-5">
                <i class="fa fa-bell mr-1"></i>
                {{ $t('settings.titles.notifs') }}
              </h2>
              <div class="form-row row">
                <div class="col-4">
                  <label class="notif-label">{{ $t('settings.form.webnotifs') }}</label>
                  <UiBadge 
                    :type="notificationEnabled ? 'success' : 'secondary'" 
                    :label="notificationEnabled ? $t('settings.form.webnotifs_enabled') : $t('settings.form.webnotifs_disabled')"
                  />
                </div>
                <div class="col" @click="handleWebNotifications" v-html="$t('settings.form.webnotifsdetails', { theme: appTheme })"></div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.alertsound') }}</label>
                <div class="col">
                  <UiSwitch v-model="playSound" @input="toggleSound" :true-value="1" :false-value="0" />
                </div>
              </div>
              <div class="form-row row" :class="{disabled:playSound === 0}">
                <label class="col-4">{{ $t('settings.form.alertsoundLoop') }}</label>
                <div class="col">
                  <UiSwitch v-model="playSoundLoop" @input="toggleSoundLoop" :true-value="1" :false-value="0" />
                </div>
              </div>

              <h2 class="mt-5">
                <i class="fa fa-desktop mr-1"></i>
                {{ $t('settings.titles.ui') }}
              </h2>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.gpsaccuracy') }}</label>
                <div class="col">
                  <UiSwitch v-model="gpsAccuracy" @input="toggleGpsAccuraccy" :true-value="1" :false-value="0" />
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.denseMode') }}</label>
                <div class="col">
                  <UiSwitch v-model="denseMode" @input="toggleDenseMode" :true-value="1" :false-value="0" />
                </div>
              </div>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.globalPerPage') }}</label>
                <!--<input type="text" v-model="globalPerPage" class="form-input col" />-->
                <div class="col">
                  <select v-model.number="globalPerPage" class="form-input col" @change="updateGlobalPerPage">
                    <option val="10">10</option>
                    <option val="20">20</option>
                    <option val="30">30</option>
                    <option val="50">50</option>
                    <option val="100">100</option>
                  </select>
                </div>
              </div>

              <h2 class="mt-5 d-inline-flex align-items-center">
                <i v-html="cookieLogo" class="mr-2"></i>
                {{ $t('settings.titles.cookies') }}
              </h2>
              <div class="form-row row">
                <label class="col-4">{{ $t('settings.form.cookiesManager') }}</label>
                <div class="col">
                  <Btn class="primary reverse col" style="text-align: center;"
                       @click.native.prevent="openCookiesManager">{{ $t('settings.form.cookiesManagerEdit') }}
                  </Btn>
                </div>
              </div>
              <div class="form-row row" style="text-align: center;margin-bottom: 0;display: block;">
                <small>Version: {{ version }}</small>
              </div>
            </div>
          </UiCard>
        </div>
      </div>
    </div>
    <Toolbar>
      <!-- <Btn :class="'primary pull-right'" @click.native.prevent="validForm()" v-show="false">{{ $t('global.save') }}</Btn> -->
    </Toolbar>
  </div>
</template>

<script>

import Auth from '@/services/auth.js';
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import SuperTable from "@/components/ui/Table";
import ValidationHandler from "@/components/ui/fields/InputValidationHandler";
import PasswordForm from "@/components/settings/PasswordForm"
import UiBadge from '@/components/ui/Badge'
import UiCard from '@/components/ui/Card'
import UiSwitch from '@/components/ui/Switch'

import Utils from '@/services/utils'

import _mapValues from 'lodash/mapValues'
import Globals from '@/services/globals.js'
import languages from '@/mixins/languages.js'
import CookieLogo from '@/assets/img/cookie.svg'


const ENGIEClients = ['SDF0001', 'SDF3032', 'SDF3315', 'SDF3321', 'SDF3351', 'SDF3433']

export default {
  name: 'MeForm',
  components: {
    Titlebar,
    Toolbar,
    Btn,
    SuperTable,
    ValidationHandler,
    UiBadge,
    UiCard,
    UiSwitch,
  },
  mixins: [languages],
  computed: {
    appTheme() {
      return Utils.getApplicationName()
    },
    cookieLogo() {
      return CookieLogo
    },
    userTelephone() {
      if (this.user.tel) {
        if (this.user.tel.charAt(0) !== '0') {
          return '+' + this.user.tel
        } else {
          return this.user.tel
        }
      } else {
        return null
      }
    },
    version() {
      return VERSION_COM;
    },
    isENGIEClient() {
      return ENGIEClients.includes(window.V.clientInfos.code)
    }
  },
  data: () => ({
        user: {
          nom: Auth.user.name,
          email: Auth.user.email,
          tel: Auth.user.telephone,
          clientCode: window.V.clientInfos.code
        },
        password: '',
        passwordConfirm: '',
        showErrors: {
          nom: false,
          email: false,
          pwd: false
        },
        playSound: 1,
        playSoundLoop: 0,
        gpsAccuracy: 1,
        denseMode: 1,
        globalPerPage: 10,
        notificationEnabled: false
      }
  ),
  methods: {
    validForm: function () {
      this.hideAllErrors();
      this.$validator.validateAll().then(() => {
      }).catch(() => {
        this.showAllErrors();
      });
    },
    showAllErrors: function () {
      for (var showError in this.showErrors) {
        this.showErrors[showError] = true;
      }
    },
    hideAllErrors: function () {
      for (var showError in this.showErrors) {
        this.showErrors[showError] = false;
      }
    },
    hideError: function (key) {
      this.showErrors[key] = false;
    },

    handleWebNotifications: function () {
      if (window.Notification && Notification.permission === "granted") {
      } else if (window.Notification && Notification.permission !== "denied") {
        let that = this
        Notification.requestPermission(function (status) {
          if (Notification.permission !== status) {
            Notification.permission = status;
          }
          that.notificationEnabled = status === "granted"
        });
      }
    },

    toggleSound: function () {
      window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_PLAY_ALERT_SOUND', this.playSound);
    },

    toggleSoundLoop: function () {
      window.V.$localStorage.set('BPZ_LOOP_ALERT_SOUND', this.playSoundLoop);
    },

    toggleGpsAccuraccy() {
      window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_GPS_ACCURACY', this.gpsAccuracy);
    },

    toggleDenseMode() {
      window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_DENSE_MODE', this.denseMode);
    },

    openPasswordModal() {
      window.Vfc.modalProps = {
        title: Utils.t('settings.form.passwordEdit'),
        width: '450px',
        height: 'auto'
      };
      window.Vfc.modalComponentProps = {
        userId: Auth.user.iduser
      };
      window.Vfc.modalComponent = PasswordForm;
      window.Vfc.$refs.modal.show();
    },
    openCookiesManager() {
      tarteaucitron.userInterface.openPanel();
    },

    renderLabel(item) {
      return item.flag + ' ' + item.label
    },

    updateGlobalPerPage() {
      window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_GLOBAL_PER_PAGE', this.globalPerPage);
      Globals.perPage = this.globalPerPage
    }
  },
  mounted() {
    var lsPlaySound = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_PLAY_ALERT_SOUND');
    if (lsPlaySound === '0') {
      this.playSound = 0;
    }
    var lsPlaySoundLoop = window.V.$localStorage.get('BPZ_LOOP_ALERT_SOUND');
    if (lsPlaySoundLoop === '1') {
      this.playSoundLoop = 1;
    }
    var lsGpsAccuracy = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_GPS_ACCURACY');
    if (lsGpsAccuracy === '0') {
      this.gpsAccuracy = 0;
    }
    var lsDenseMode = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_DENSE_MODE');
    if (lsDenseMode === '0') {
      this.denseMode = 0;
    }
    var lsGlobalPerpage = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_GLOBAL_PER_PAGE');
    if (lsGlobalPerpage) {
      this.globalPerPage = lsGlobalPerpage;
    } else {
      this.globalPerPage = 30;
      this.updateGlobalPerPage()
    }
    this.notificationEnabled = window.Notification && Notification.permission === "granted"
    window.Vfc.$refs.loading.hide();
  },
}
</script>

<style lang="scss" scoped>
.notif-label {
  height:auto
}
</style>
